//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Building from './_building'
export default {
    components: {
        Building
    },
    props: {
        'paging-enabled': {
            type: Boolean,
            default: false
        },
        selected_index: Number,
        items: Array,
        category: String,
        classname: String,
        loading: Boolean,
    },
    methods: {
        onSelect (i) {
            this.$emit('select', i)
        },
    }
}
